import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { LayoutModule } from '../../../../layout/modules';
import { useRedirectAreaDetail } from './hook';
import { RedirectAreaData } from './data';
import { RedirectAreaParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    REDIRECT_AREA_NEW,
    REDIRECT_AREA,
    REDIRECT_AREA_EDIT,
    REDIRECT_AREA_DETAIL,
} from '../../../../../routes/paths';
import { RedirectAreaRegisterHistory } from './registerHistory';

export const RedirectAreaDetail = () => {
    const {
        redirectArea,
        redirectAreaHistorical,
        showHistorical,
        setShowHistorical,
    } = useRedirectAreaDetail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle área redirección PQR"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={redirectArea?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: REDIRECT_AREA_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: REDIRECT_AREA,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: REDIRECT_AREA_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: REDIRECT_AREA_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(redirectArea?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <RedirectAreaParamsHistorical
                            historical={redirectAreaHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <RedirectAreaData data={redirectArea} />
                </LayoutModule>
            </LayoutModule>
            <RedirectAreaRegisterHistory redirectArea={redirectArea} />
        </>
    );
};
